"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { useRef, useState } from "react";
import { ProgressStepper } from "../../progress-stepper";
import { Stepper } from "../../stepper";
import { stepFieldsMap } from "../../steps/fields";
import type { NavigationState, StepConfig } from "../../types/step";
import { MobileHeader } from "../ui/MobileHeader";
interface PostPropertyLayoutProps {
  children: ReactNode;
  stepConfig: StepConfig;
  navigationState: NavigationState;
  rawUnitData: any;
  rawUnitId?: string | null;
  sellerUnitId?: string | null;
  steps: StepConfig[];
  onBack?: () => void;
  onStepClick?: (stepNumber: number) => void;
  disableBack?: boolean;
  urlGroupId: string | null;
}
export function PostPropertyLayout(t0) {
  const $ = _c(57);
  const {
    children,
    stepConfig,
    navigationState,
    rawUnitData,
    steps,
    rawUnitId,
    sellerUnitId,
    urlGroupId,
    onBack,
    onStepClick,
    disableBack
  } = t0;
  const [showMobileStepper, setShowMobileStepper] = useState(false);
  const mobileScrollRef = useRef(null);
  const desktopScrollRef = useRef(null);
  const handleBack = navigationState.canGoBack ? onBack : undefined;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShowMobileStepper(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== disableBack || $[2] !== handleBack || $[3] !== stepConfig.title) {
    t2 = <MobileHeader title={stepConfig.title} onBack={handleBack} onTitleClick={t1} disableBack={disableBack} />;
    $[1] = disableBack;
    $[2] = handleBack;
    $[3] = stepConfig.title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== navigationState.currentStep || $[6] !== navigationState.totalSteps) {
    t3 = <Stepper currentStep={navigationState.currentStep} totalSteps={navigationState.totalSteps} />;
    $[5] = navigationState.currentStep;
    $[6] = navigationState.totalSteps;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex-shrink-0">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== children) {
    t5 = <div className="flex-1 flex flex-col min-h-0 relative"><div ref={mobileScrollRef} className="flex-1 overflow-y-auto overflow-x-hidden scrollbar-thin"><div className="p-6 sm:p-6 pb-20">{children}</div></div></div>;
    $[11] = children;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== navigationState.currentStep || $[14] !== onStepClick || $[15] !== rawUnitData || $[16] !== rawUnitId || $[17] !== sellerUnitId || $[18] !== showMobileStepper || $[19] !== steps || $[20] !== urlGroupId) {
    t6 = showMobileStepper && <div className="fixed inset-0 z-50 bg-black/50"><div className="h-full bg-white"><ProgressStepper steps={steps} currentStep={navigationState.currentStep} data={rawUnitData} rawUnitId={rawUnitId} sellerUnitId={sellerUnitId} urlGroupId={urlGroupId} info={stepFieldsMap} onClose={() => setShowMobileStepper(false)} onStepClick={onStepClick} /></div></div>;
    $[13] = navigationState.currentStep;
    $[14] = onStepClick;
    $[15] = rawUnitData;
    $[16] = rawUnitId;
    $[17] = sellerUnitId;
    $[18] = showMobileStepper;
    $[19] = steps;
    $[20] = urlGroupId;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t4 || $[23] !== t5 || $[24] !== t6) {
    t7 = <div className="lg:hidden h-screen flex flex-col bg-white">{t4}{t5}{t6}</div>;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      height: "calc(100vh - 80px)"
    };
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== navigationState.currentStep || $[28] !== onStepClick || $[29] !== rawUnitData || $[30] !== rawUnitId || $[31] !== sellerUnitId || $[32] !== steps || $[33] !== urlGroupId) {
    t9 = <div className="w-[320px] flex-shrink-0 rounded-xl bg-white border border-neutral-200 overflow-hidden shadow-sm h-full"><ProgressStepper steps={steps} currentStep={navigationState.currentStep} rawUnitId={rawUnitId} data={rawUnitData} sellerUnitId={sellerUnitId} urlGroupId={urlGroupId} info={stepFieldsMap} onStepClick={onStepClick} /></div>;
    $[27] = navigationState.currentStep;
    $[28] = onStepClick;
    $[29] = rawUnitData;
    $[30] = rawUnitId;
    $[31] = sellerUnitId;
    $[32] = steps;
    $[33] = urlGroupId;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== disableBack || $[36] !== handleBack || $[37] !== stepConfig.description || $[38] !== stepConfig.title) {
    t10 = <MobileHeader title={stepConfig.title} subtitle={stepConfig.description} onBack={handleBack} disableBack={disableBack} />;
    $[35] = disableBack;
    $[36] = handleBack;
    $[37] = stepConfig.description;
    $[38] = stepConfig.title;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  let t11;
  if ($[40] !== navigationState.currentStep || $[41] !== navigationState.totalSteps) {
    t11 = <Stepper currentStep={navigationState.currentStep} totalSteps={navigationState.totalSteps} />;
    $[40] = navigationState.currentStep;
    $[41] = navigationState.totalSteps;
    $[42] = t11;
  } else {
    t11 = $[42];
  }
  let t12;
  if ($[43] !== t10 || $[44] !== t11) {
    t12 = <div className="flex-shrink-0">{t10}{t11}</div>;
    $[43] = t10;
    $[44] = t11;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] !== children) {
    t13 = <div className="flex-1 flex flex-col min-h-0 relative"><div ref={desktopScrollRef} className="flex-1 overflow-y-auto overflow-x-hidden scrollbar-thin"><div className="p-6">{children}</div></div></div>;
    $[46] = children;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  let t14;
  if ($[48] !== t12 || $[49] !== t13) {
    t14 = <div className="flex-1 max-w-4xl rounded-xl bg-white border border-neutral-200 shadow-sm overflow-hidden h-full flex flex-col">{t12}{t13}</div>;
    $[48] = t12;
    $[49] = t13;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  let t15;
  if ($[51] !== t14 || $[52] !== t9) {
    t15 = <div className="hidden lg:flex justify-center p-6 gap-6" style={t8}>{t9}{t14}</div>;
    $[51] = t14;
    $[52] = t9;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== t15 || $[55] !== t7) {
    t16 = <div className="min-h-screen bg-neutral-50 lg:bg-[#F8F8FA]">{t7}{t15}</div>;
    $[54] = t15;
    $[55] = t7;
    $[56] = t16;
  } else {
    t16 = $[56];
  }
  return t16;
}